
        // =======================================================================
        // Subjects list view
        // =======================================================================
        
        // =======================================================================
        // Travel — protective travel packages (IPOE)
        // =======================================================================
        const TRIP_RISK_DIMENSIONS = [
            ['kidnap_ransom', 'Kidnap & Ransom'],
            ['targeted_crime', 'Targeted Crime'],
            ['opportunistic_crime', 'Opportunistic Crime'],
            ['terrorism', 'Terrorism'],
            ['medical', 'Medical Emergency'],
            ['civil_unrest', 'Civil Unrest'],
            ['natural_environmental', 'Natural / Environmental'],
            ['surveillance_cyber', 'Surveillance / Cyber'],
            ['reputational_media', 'Reputational / Media'],
        ];

export { TRIP_RISK_DIMENSIONS };
